import { memo } from 'react';
import { Rectangle } from 'react-leaflet';
import { useSelector } from 'react-redux';

import { DEFAULT_SHAPE_COLOR, HEATMAP_DEFAULT_OPACITY, HEATMAP_GRID_SIZE, HEATMAP_OPTIONS } from './constants';

function transformToHeatmapData(data) {
  if (!Array.isArray(data) || data.length === 0) return [];

  const speeds = data.map(item => item?.livestockActivity?.speed_to).filter(v => typeof v === 'number' && !isNaN(v));

  if (speeds.length === 0) return [];

  return data.map(item => {
    const lat = item.lat_center;
    const lon = item.lon_center;
    const intensity = item?.activity_type_count;

    return [lat, lon, intensity];
  });
}

function getRectangleOptions(styles, intensity) {
  const style = styles?.find(s => intensity >= s.min_count && intensity <= s.max_count);
  const color = style?.color_hex ?? DEFAULT_SHAPE_COLOR;

  return { ...HEATMAP_OPTIONS, color, fillColor: color, fillOpacity: style?.opacity ?? HEATMAP_DEFAULT_OPACITY };
}

function HeatmapLayer({ points }) {
  const transformedHeatmapData = transformToHeatmapData(points);
  const { styles } = useSelector(state => state.grazing);

  return (
    <>
      {transformedHeatmapData?.map(([lat, lng, intensity], i) => {
        const bounds = [
          [lat - HEATMAP_GRID_SIZE / 2, lng - HEATMAP_GRID_SIZE / 2],
          [lat + HEATMAP_GRID_SIZE / 2, lng + HEATMAP_GRID_SIZE / 2]
        ];

        return <Rectangle key={i} bounds={bounds} pathOptions={getRectangleOptions(styles, intensity)} />;
      })}
    </>
  );
}

export default memo(HeatmapLayer);
